import { tv } from 'tailwind-variants';

export const row = tv({
  base: 'w-full xs:px-4 lg:px-8 py-2 bg-color-lightest h-16 shadow-level-1 z-[9999] relative',
  variants: {
    visibility: {
      show: 'flex flex-row',
      hide: 'hidden',
    },
  },
});
